import * as PIXI from "pixi.js";
import Main from "../../Main"


export default class BaseInfoBox extends PIXI.Container {
  private Main = Main.getInstance();
  startScale = .2;
  isVertical: boolean
  constructor() {
    super();
    const dim = this.Main.getDim();
    this.isVertical = dim.width < dim.height ? true : false;
    this.scale.set(.2);
  }
  addCoord(x: number, y: number) {
    const dim = this.Main.getDim();
    this.x = dim.width / 2 + x;
    this.y = dim.height / 2 + y;
  }

  addText(text: string, y: number, wordWrapWidth) {
    const line = new PIXI.Text({ text })
    line.style = {
      fill: 0xFFFFFF,
      fontWeight: "700",
      wordWrap: true,
      wordWrapWidth,
      align: "center"
    }
    line.anchor.set(.5);
    line.y = y;
    this.addChild(line);
  }
  addBg(width: number, height: number, fillColor: number, strokeColor: number) {
    const bg = new PIXI.Graphics()
      .roundRect(-width / 2, 0, width, height, 20)
      .fill(fillColor)
      .stroke({ color: strokeColor, width: 4 })
    this.addChild(bg);
  }
}